import { Reveal } from "@/components/Reveal";
import { TechLabel } from "@/components/kit";

export const PageHeader = ({ eyebrow, index, title, description, children }) => (
    <section className="relative overflow-hidden border-b border-white/[0.08] pb-14 pt-28 md:pb-16 md:pt-36">
        <div className="absolute inset-0 bg-grid opacity-40" aria-hidden="true" />
        <div
            className="absolute inset-0"
            style={{ background: "radial-gradient(50% 70% at 15% 0%, rgba(22,119,255,0.16) 0%, transparent 60%)" }}
            aria-hidden="true"
        />
        <div className="shell relative">
            <Reveal>
                {eyebrow && (
                    <TechLabel className="mb-5">
                        {index ? `${index} / ` : ""}
                        {eyebrow}
                    </TechLabel>
                )}
                <h1 className="font-display text-[clamp(2.3rem,6vw,4.4rem)] font-bold uppercase leading-[1.0] tracking-tightest text-ink">
                    {title}
                </h1>
                {description && <p className="mt-5 max-w-2xl text-base leading-relaxed text-mute md:text-lg">{description}</p>}
                {children}
            </Reveal>
        </div>
    </section>
);

export default PageHeader;
